var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "data-update-log-detail" }, [
    _c("div", [_vm._v("{")]),
    _c(
      "ul",
      { staticStyle: { overflow: "auto" } },
      _vm._l(_vm.detail, function(item, index) {
        return _c("li", { key: index }, [
          _c("span", {
            staticStyle: { "margin-left": "20px" },
            domProps: { innerHTML: _vm._s(item.content) }
          })
        ])
      }),
      0
    ),
    _c("div", [_vm._v("}")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }